import { Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IWalletData } from '@app/core/http/custody-crypto/custody-crypto.interface';
import { CustodyCryptoService } from '@app/core/http/custody-crypto/custody-crypto.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from 'ngx-venus';
import { finalize, takeWhile } from 'rxjs/operators';
import { interval, timer } from 'rxjs';

@Component({
  selector: 'app-custody-crypto',
  templateUrl: './custody-crypto.component.html',
  styleUrls: ['./custody-crypto.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class CryptoCustodyComponent implements OnInit, OnDestroy {
  constructor(
    private route: ActivatedRoute,
    public alertService: AlertService,
    private translateService: TranslateService,
    private custodyCryptoService: CustodyCryptoService,
  ) {}

  data!: IWalletData;
  isDepositSuccess = false;
  countdown = 10;

  ngOnInit() {
    this.route.queryParams.subscribe({
      next: (params: any) => {
        if (params.token) {
          const helper = new JwtHelperService();
          const decodedToken = helper.decodeToken(params.token);
          this.data = decodedToken;
          const language = this.data.language?.toLowerCase();
          if (language) {
            this.translateService.use(language);
          }
        }
      },
      error: (error) => {
        this.alertService.setNotice('Error loading wallet data', 'warning');
      },
    });

    this.startStatusCheckTimer(30000);
  }

  startStatusCheckTimer(ms: number = 0) {
    timer(ms)
      .pipe(untilDestroyed(this))
      .subscribe(() => this.checkWalletStatus());
  }

  checkWalletStatus() {
    this.custodyCryptoService
      .getWalletStatus(this.data.walletAddress, this.data.MID)
      .pipe(
        finalize(() => {
          if (!this.isDepositSuccess) {
            this.startStatusCheckTimer(10000);
          }
        }),
        untilDestroyed(this),
      )
      .subscribe({
        next: (status) => {
          if (status === 'approved') {
            this.showSuccessScreen();
          }
        },
        error: (error) => {
          this.alertService.setNotice(
            'Error checking wallet status',
            'warning',
          );
        },
      });
  }

  showSuccessScreen() {
    this.isDepositSuccess = true;
    this.countdown = 10;

    interval(1000)
      .pipe(
        takeWhile(() => this.countdown > 0),
        untilDestroyed(this),
      )
      .subscribe(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          window.location.href = this.data.returnUrl;
        }
      });
  }

  getCryptoIconPath(currencyCode: string): string {
    const iconMap: Record<string, string> = {
      'USDT.TRC20': 'usdt',
      'USDT.ERC20': 'usdt',
    };

    const iconName =
      iconMap[currencyCode]?.toLowerCase() || currencyCode?.toLowerCase();
    return `/assets/img/cryptocurrency-icons/${iconName}.svg`;
  }

  backToMerchant() {
    window.location.href = this.data.returnUrl;
  }

  ngOnDestroy() {}
}
